import React, { Component } from 'react';
import Chart from 'chart.js';
import Skeleton from 'react-loading-skeleton';
import { commaingNumber } from '../../../utils';
import { DS_CHART_TOKENS, chartDownloadFileName, getCanvasChartColor } from '../../../utils/chartTheme';
import { DownloadPngButton } from '../pngExport';

const mapGraphColor = (color) => (
  Array.isArray(color) ? color.map(getCanvasChartColor) : getCanvasChartColor(color)
);

class Bargraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myChart: null,
    };
  }
  
  drawGraph = () => {
    var ctx = document.getElementById(this.props.id).getContext('2d');

    /**setting width of bar graph*/
    ctx.canvas.parentNode.style.width = this.props.width;

    const getBarTag = (type, value) => {
      if (!type) return '';
      else if (type === 'value') return value;
      else if (type === 'amount') return formatValue(value) ;
      else if (type === 'percentage') return value + '%';
      else if(type === 'in-thousands') return value + 'K';
    };

    const getDependentValue = (type, value) => {
      if (!type) return commaingNumber(value);
      else if (type === 'percentage') return value + '%';
      else if (type === 'amount') return formatValue(value);
      else if (type === 'rupees') return '₹' + commaingNumber(value);
      else if (type === 'in-thousands') return value + 'K';
    };

    const formatValue = (value) =>{
      if (value >= 10000000) {
        return (value / 10000000).toFixed(2) + ' Cr'; // Crores
      } else if (value >= 100000) {
        return (value / 100000).toFixed(2) + ' L'; // Lakhs
      } else if (value >= 1000) {
        return (value / 1000).toFixed(2) + 'K'; // Thousands
      }
      return value;
    }
  
    const hasObjects = (arr) => Array.isArray(arr) && arr.length > 0 && typeof arr[0] === 'object' && arr[0] !== null;

    const getDatasetData = (item) => {
      if (hasObjects(item)) return item.map(d => d.v);
      return item;
    };

    const getDatasetTags = (item) => {
      if (hasObjects(item)) return item.map(d => d.t);
      return null;
    };

    if (this.state.myChart) {
      this.state.myChart.destroy();
    }

    this.state.myChart = new Chart(ctx, {
      type: this.props.type,
      data: {
        labels: this.props.labels,
        datasets: this.props.stacked
          ? this.props.data.map((item, index) => {
              return {
                data: getDatasetData(item),
                tagData: getDatasetTags(item),
                backgroundColor: getCanvasChartColor(this.props.backgroundColor[index]),
              };
            })
          : [
              {
                data: getDatasetData(this.props.data),
                tagData: getDatasetTags(this.props.data),
                backgroundColor: mapGraphColor(this.props.backgroundColor),
              },
            ],
      },

      options: {
        maintainAspectRatio: false /**to set custom height and width of bar graph set maintainAspectRatio to false*/,
        barTag: this.props.barTag,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        scales: {
          xAxes: [
            {
              maxBarThickness: this.props.type === 'horizontalBar' ? 18 : 16,
              barThickness: this.props.type === 'horizontalBar' ? 14 : 12,
              scaleLabel: {
                // Without a title Chart.js would print "undefined" along the axis.
                display: !!this.props.xAxesLabel,
                labelString: this.props.xAxesLabel,
                fontStyle: 'bold',
                fontSize: 11,
                fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray700),
                fontFamily: 'Inter',
              },
              gridLines: {
                display: false,
                color: getCanvasChartColor(DS_CHART_TOKENS.gray200),
                drawBorder: true,
                zeroLineColor: getCanvasChartColor(DS_CHART_TOKENS.gray300),
              },
              ticks:
                this.props.type === 'horizontalBar'
                  ? {
                      ...this.props.ticks,
                      fontFamily: '"JetBrains Mono"',
                      fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray600),
                      fontSize: 11,
                      padding: 8,
                      callback: (value) => {
                        return getDependentValue(this.props.dataPoints, value);
                      },
                    }
                  : {
                      autoSkip: false,
                      fontFamily: 'Inter',
                      fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray700),
                      fontSize: 12,
                      callback: function (label, index, labels) {
                        if (/\s/.test(label)) {
                          const result = label.split(' ').filter((item) => !['', '-', '&amp;'].includes(item));
                          return result.length > 3 ? [...result.slice(0, 3), '...'] : result;
                          // return result;
                        } else {
                          return label;
                        }
                      },
                    },
              stacked: !!this.props.stacked,
            },
          ],
          yAxes: [
            {
              maxBarThickness: this.props.type === 'horizontalBar' ? 18 : 16,
              barThickness: this.props.type === 'horizontalBar' ? 14 : 12,
              scaleLabel: {
                // Without a title Chart.js would print "undefined" along the axis.
                display: !!this.props.yAxesLabel,
                labelString: this.props.yAxesLabel,
                fontStyle: 'bold',
                fontSize: 11,
                fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray700),
                fontFamily: 'Inter',
              },
              gridLines: {
                drawBorder: false,
                display: !(this.props.type === 'horizontalBar'),
                color: getCanvasChartColor(DS_CHART_TOKENS.gray200),
                zeroLineColor: getCanvasChartColor(DS_CHART_TOKENS.gray300),
              },
              ticks:
                this.props.type === 'bar'
                  ? {
                      beginAtZero: true,
                      ...this.props.ticks,
                      fontFamily: '"JetBrains Mono"',
                      fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray600),
                      fontSize: 11,
                      padding: 8,
                      callback: (value) => {
                        return getDependentValue(this.props.dataPoints, value);
                      },
                    }
                  : { fontFamily: 'Inter', fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray700), fontSize: 12 },
              stacked: !!this.props.stacked,
            },
          ],
        },
        hover: {
          animationDuration: 0,
        },

        animation: {
          duration: 1,
          onComplete: function () {
            var chartInstance = this.chart;
            ctx = chartInstance.ctx;
            ctx.textAlign = 'center';
            ctx.font = Chart.helpers.fontString(11, '500', '"JetBrains Mono"');
            ctx.fillStyle = getCanvasChartColor(DS_CHART_TOKENS.gray700);
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach((dataset, i) => {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach((bar, index) => {
                const displayVal = dataset.tagData ? dataset.tagData[index] : dataset.data[index];
                var data = getBarTag(this.config.options.barTag, displayVal);
                ctx.fillText(data, bar._model.x, bar._model.y - 5);
              });
            });
          },
        },
      },
    });
  };

  componentDidMount() {
    if (!this.props.loading) this.drawGraph();
  }

  componentDidUpdate() {
    if (!this.props.loading) this.drawGraph();
  }

  chartWidth = () => Math.max(((this.props.labels?.length || 0) * 90), 1100);

  nodeRef = React.createRef();

  render() {
    if (this.props.loading) {
      return <Skeleton width="100%" height={this.props.loaderHeight} />;
    }

    // withDownload: standalone usage adds its own PNG button; kept off by
    // default because GraphCard already wraps this chart with one.
    if (this.props.withDownload) {
      return (
        <div ref={this.nodeRef} className="relative">
          <div className="absolute right-2 top-2 z-10" data-download-ignore="true">
            <DownloadPngButton
              nodeRef={this.nodeRef}
              fileName={chartDownloadFileName(this.props.title, 'bar-graph')}
            />
          </div>
          {this.renderChart()}
        </div>
      );
    }

    return this.renderChart();
  }

  renderChart() {
    if (this.props.type === "horizontalBar") {
      return (
        <div className="p-4 h-full pt-0">
          <canvas
            id={this.props.id}
            style={{ height: this.props.height }}
          ></canvas>
          <hr
            className="relative -top-12 left-28"
            style={{ width: "81%", borderTop: "1px solid var(--gray-300)" }}
          />
        </div>
      );
    }

    return (
      <div className="p-4 h-full overflow-x-scroll pt-6">
        <div
          className="chart-container"
          style={{ width: `${this.chartWidth()}px` }}
        >
          <div>
            <canvas
              id={this.props.id}
              style={{ height: this.props.height }}
            ></canvas>
          </div>
        </div>
      </div>
    );
  }
}  

export default Bargraph;
